import { Component, OnInit, Input } from '@angular/core';
import { BotonTipo } from '../../../../components/boton/boton';
import { MatDialog } from '@angular/material';
import { Contacto } from '../../../../interfaces/contacto';

@Component({
  selector: 'app-whatsapp-contacto',
  templateUrl: './whatsapp-contacto.component.html',
  styleUrls: ['./whatsapp-contacto.component.scss']
})
export class WhatsappContactoComponent implements OnInit {
  @Input() type: BotonTipo;
  @Input() contacto?: Contacto;
  @Input() disabled: boolean = false;
  @Input() tooltipDir: string = 'below';

  constructor(
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    if (!this.type) {
      throw "La variable Input 'type' es requerida";
    }
    if (!this.contacto) {
      throw "La variable Input 'contacto' es requerida";
    }
  }

  enviarWhatsapp() {

    let numero= (this.contacto.celularCodigoPais)?this.contacto.celularCodigoPais:'549';
    numero+=(this.contacto.celularCodigoArea)?this.contacto.celularCodigoArea:'';
    numero+=this.contacto.celularNumero;
    let url = "https://wa.me/" + numero;
    let titulo = "Enviar whatsapp a [" + this.contacto.celularCodigoPais + this.contacto.celularCodigoArea + this.contacto.celularNumero + "]";
    //console.log(numero,'conasdftacto');
    
    this.openPopupOnCenterScreen(url, titulo, '800', '600');
  }

  openPopupOnCenterScreen(url, title, w, h) {
    // Fixes dual-screen position                         Most browsers      Firefox
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;
    var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }
}
